export const positionsStatesFiltersOpts = [
  {
    key: 'DEFAULTED',
    text: 'Defaulted'
  },
  {
    key: 'DELINQUENT',
    text: 'Delinquent'
  },
  {
    key: 'TRADE',
    text: 'Trade'
  },
  {
    key: 'COMPLETED',
    text: 'Settled'
  }
]
